module.exports = __webpack_public_path__ + "static/img/active_default.8e37dd3e.jpg";